import { render } from "./sort_dropdown.vue?vue&type=template&id=6127b0c5&scoped=true"
import script from "./sort_dropdown.vue?vue&type=script&lang=js"
export * from "./sort_dropdown.vue?vue&type=script&lang=js"

import "./sort_dropdown.vue?vue&type=style&index=0&id=6127b0c5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6127b0c5"]])

export default __exports__